<template>
  <div class="order-list main-content">
    <div class="filter-content">
      <div class="time-content">
        <el-col class="line" :span="4">录入时间</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="开始日期" value-format="timestamp" :picker-options="pickerOptionOrdStart"
                          v-model="order_start" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">至</el-col>
        <el-col :span="9">
          <el-date-picker type="date" placeholder="结束日期" value-format="timestamp" :picker-options="pickerOptionOrdEnd"
                          v-model="order_end" style="width: 100%;"></el-date-picker>
        </el-col>
      </div>
      <el-button type="primary" class="search-btn" @click="searchHandle">搜索</el-button>
      <el-button type="success" class="search-btn export-btn" @click="exportClick" :disabled="export_dis">导出数据</el-button>
    </div>
    <el-table
      :data="listData"
      v-loading="loading"
      border
      header-row-class-name="change-header-style"
      height="460"
      style="width: 100%;margin-top: 20px;">
      <el-table-column
        type="index"
        :index="indexHandle"
        label="序号"
        width="50"
        fixed="left">
      </el-table-column>
      <el-table-column
        prop="strProjectName"
        width="280"
        label="项目名称"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="proj_name_search" placeholder="项目名称" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCustomerName"
        label="客户姓名"
        width="140"
        fixed="left">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="user_name_search" placeholder="客户姓名" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCustomerGender"
        width="50"
        label="性别">
      </el-table-column>
      <el-table-column
        prop="nCustomerAge"
        label="年龄"
        width="50">
      </el-table-column>
      <el-table-column
        prop="strCustomerMobile"
        label="手机号码"
        width="120">
      </el-table-column>
      <el-table-column
        prop="strCheckCode"
        label="识别码"
        width="190">
      </el-table-column>
      <el-table-column
        prop="nMatchStatus"
        label="匹配状态"
        width="100">
        <template slot="header" slot-scope="scope">
          <el-select v-model="matching_state_select" placeholder="匹配状态" popper-class="new_filter_options" size="mini"
                     @change="searchHandle">
            <el-option
              v-for="item in matching_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="getMatchStateItem(scope.row.nMatchStatus)"
               :style="'padding:4px 8px;background:' + ((getMatchStateItem(scope.row.nMatchStatus).attr && getMatchStateItem(scope.row.nMatchStatus).attr.color) || getMatchStateItem(scope.row.nMatchStatus).color || '') + ';color:#fff;text-align: center;border-radius: 4px;'">
            {{ getMatchStateItem(scope.row.nMatchStatus).name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="nExamineStatus"
        label="审核状态"
        width="120">
        <template slot="header" slot-scope="scope">
          <el-select v-model="examine_state_select" placeholder="审核状态" popper-class="new_filter_options" size="mini"
                     @change="searchHandle">
            <el-option
              v-for="item in examine_state_options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :style="{ '--bgcolor': (item.attr && item.attr.color) ? item.attr.color : '#ffffff' }">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope">
          <div v-if="getExamineStateItem(scope.row.nExamineStatus)"
               :style="'padding:4px 8px;background:' + ((getExamineStateItem(scope.row.nExamineStatus).attr && getExamineStateItem(scope.row.nExamineStatus).attr.color) || getExamineStateItem(scope.row.nExamineStatus).color || '') + ';color:#fff;text-align: center;border-radius: 4px;'">
            {{ getExamineStateItem(scope.row.nExamineStatus).name }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        width="160"
        prop="nReceiveTime"
        label="录入时间">
        <template slot-scope="scope">
          <div v-if="scope.row.nReceiveTime != 0 && scope.row.nReceiveTime != null">
            {{ scope.row.nReceiveTime | FormatDate('yyyy-MM-dd hh:mm:ss') }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="strCheckupCode"
        label="客户编码"
        width="210">
        <template slot="header" slot-scope="scope">
          <el-input @keyup.enter.native="searchHandle" v-model="exam_code_search" placeholder="客户编码" clearable size="mini">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="searchHandle" style="cursor: pointer;"></i>
          </el-input>
        </template>
      </el-table-column>
      <el-table-column
        width="170"
        label="操作"
        fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" title="操作记录" icon="el-icon-s-order" @click="showOperationDia(scope.row)"></el-button>
          <el-button v-if="scope.row.nMatchStatus == 0 && scope.row.nExamineStatus != 100" @click="showEditDiaHandle(scope.row)" type="primary" title="修改"
                     style="cursor: pointer;display: inline-block;" icon="el-icon-edit" size="mini"></el-button>
          <el-button v-if="scope.row.nMatchStatus == 0" @click="delHandle(scope.row)" type="danger"
                     style="cursor: pointer;display: inline-block;" icon="el-icon-delete" title="删除"
                     size="mini"></el-button>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="no-data">
          当前暂无数据
        </div>
      </template>
    </el-table>

    <page-nation :total="page_total" @pageChange="pageChange" :current_page="current_page" :page_sizes="page_sizes"
                 :page_limit="page_limit"></page-nation>

    <el-dialog
      title="编辑"
      :visible.sync="isShowEditDia"
      width="420px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      custom-class="form-dialog"
      show-close>
      <div>
        <p class="mess">项目名称： {{orderForm.projName}}</p>
        <el-form ref="orderForm" :rules="orderFromRules" :model="orderForm" label-width="100px">
          <el-form-item label="客户姓名" prop="csrName">
            <el-input v-model="orderForm.csrName"></el-input>
          </el-form-item>
          <el-form-item label="客户性别" prop="csrGender">
            <el-radio-group v-model="orderForm.csrGender">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="客户年龄" prop="csrAge">
            <el-input-number v-model="orderForm.csrAge" :min="1" :max="150"></el-input-number>
          </el-form-item>
          <el-form-item label="手机号码" prop="csrMobile">
            <el-input v-model="orderForm.csrMobile"></el-input>
          </el-form-item>
          <el-form-item label="客户经理代码">
            <el-input v-model="orderForm.checkCode"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowEditDia = false">取 消</el-button>
        <el-button type="primary" @click="updateOrderHandle('orderForm')">确 定</el-button>
      </div>
    </el-dialog>

    <operation-record ref="operation_record"></operation-record>

  </div>
</template>

<script>
import PageNation from "./Common/PageNation";
import OperationRecord from "./Common/OperationRecord";
import ApiService from "../service/ApiService";
import pub from "../service/public";
export default {
  name: "CustomerList",
  components:{
    PageNation:PageNation,
    OperationRecord:OperationRecord,
  },
  data(){
    return {
      listData: [],
      loading: false,
      order_start: '',  // 发单时间
      order_end: '',
      pickerOptionOrdStart: {
        disabledDate: time => {
          if (this.order_end) {
            return time.getTime() > new Date(this.order_end).getTime();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      pickerOptionOrdEnd: {
        disabledDate: time => {
          if (this.order_start) {
            return time.getTime() < new Date(this.order_start).getTime() || time.getTime() > Date.now();
          } else {
            return time.getTime() > Date.now();
          }
        }
      },
      proj_name_search: '',
      user_name_search: '',
      exam_code_search: '',
      matching_state_select: -1,
      matching_options: [],
      page_total: 0,
      current_page: 1,
      page_sizes: [10, 20, 50, 100],
      page_limit: 10, // 每页多少条
      isShowEditDia: false,
      orderForm: {},
      orderFromRules: {
        csrName: [
          {required: true, message: '请输入客户姓名', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        csrGender: [
          {required: true, message: '请选择客户性别', trigger: 'change'}
        ],
        csrAge: [
          {required: true, message: '请输入客户年龄', trigger: 'blur'}
        ],
        csrMobile: [
          {required: true, message: '请输入手机号码', trigger: 'blur'}
        ],
      },
      examine_state_options: [],
      examine_state_select: -1,
      export_dis: true,
    }
  },
  created() {
    this.initConstOptions();
    this.initData();
  },
  methods:{
    indexHandle(index){
      index = (index + 1) + (this.current_page - 1) * this.page_limit;
      return index
    },
    // 翻页、切换每页条数
    pageChange(item) {
      this.current_page = item.current_page;
      if(item.type == 'size'){
        this.page_limit = item.page_limit;
      }
      this.initData(); //改变页码，重新渲染页面
    },
    initData() {
      let that = this;
      that.loading = true;
      let order_start = 0;
      let order_end = 0;
      if (that.order_start) {
        order_start = that.order_start / 1000;
      }
      if (that.order_end) {
        order_end = that.order_end / 1000;
      }

      let params = {
        page: {
          number: that.current_page - 1,
          limit: that.page_limit
        },
        keyWord: [],
        parms: {
          // 时间查询改为数组格式：有值才传，否则为空数组
          lsTimeFrame: (order_start || order_end)
            ? [
              {
                nTimeType: 5,
                nStartTime: order_start,
                nEndTime: order_end,
              }
            ]
            : [],
          strProjectName: that.proj_name_search,//项目名称
          strCustomerName: that.user_name_search,//姓名
          strCheckupCode: that.exam_code_search,//客户编码
          nMatchStatus: that.matching_state_select,//是否匹配
          nExamineStatus: that.examine_state_select,//审核状态
        }
      }

      that.listData = [];
      ApiService.getHeartOrderList(params).then(res => {
        this.loading = false;
        if (res.code === pub.backCode.SUCCESS) {
          if(res.data.pageList){
            that.listData = res.data.pageList;
            if(that.current_page == 1){
              that.page_total = res.data.itemTotal;
            }
            if(that.page_total > 0){
              that.export_dis = false;
            }else{
              that.export_dis = true;
            }
          }
        } else {
          pub.analysisReturnCode(res, () => that.initData());
        }
      }).catch(error => {
        that.loading = false;
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    // 显示编辑弹窗
    showEditDiaHandle(val){
      this.orderForm = {
        nOrderRecvId: val.nOrderRecvId,
        projName: val.strProjectName,
        csrName: val.strCustomerName,
        csrAge: val.nCustomerAge,
        csrGender: val.strCustomerGender,
        checkCode: val.strCheckCode,
        csrMobile: val.strCustomerMobile
      };
      this.isShowEditDia = true;
    },
    // 编辑之后确定按钮
    updateOrderHandle(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitUpdateOrderHandle();
        } else {
          return false;
        }
      });
    },
    // 提交更新的内容
    submitUpdateOrderHandle(){
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms:{
          nOrderRecvId: this.orderForm.nOrderRecvId,      // 订单收单id
          strCustomerName: this.orderForm.csrName,        // 客户姓名
          strCustomerGender: this.orderForm.csrGender,    // 客户性别
          strCustomerMobile: this.orderForm.csrMobile,    // 手机号
          strCheckCode: this.orderForm.checkCode,         // 识别码
          nCustomerAge: this.orderForm.csrAge,            // 客户年龄
        }

      }
      ApiService.updateHeartOrder(params).then(res => {
        this.isShowEditDia = false;
        if (res.code === pub.backCode.SUCCESS) {
          this.initData();
        } else {
          pub.analysisReturnCode(res, this.submitUpdateOrderHandle);
        }
      });
    },
    //删除
    delHandle(val) {
      this.$confirm('确定删除订单【' + ' ' + val.strCustomerName + ' (' + val.strCustomerMobile + ')】的信息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'danger'
      }).then(() => {
        this.delOrderList({ nOrderRecvId: val.nOrderRecvId, strCheckupCode: val.strCheckupCode });
      }).catch(() => {
      });
    },
    //执行删除
    delOrderList(payload){
      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms:{
          nOrderRecvId: payload.nOrderRecvId,
          strCheckupCode: payload.strCheckupCode
        }
      };
      ApiService.delHeartOrder(params).then(res => {
        if (res.code === pub.backCode.SUCCESS) {
          this.current_page = 1;
          this.initData();
        }else {
          pub.analysisReturnCode(res, () => this.delOrderList(payload));
        }
      }).catch(error => {
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    // 搜索
    searchHandle(){
      this.current_page = 1;
      this.initData();
    },
    //操作列表
    showOperationDia(item){
      this.$refs.operation_record.showOperationListDia(item);
    },
    // 初始化枚举选项
    initConstOptions() {
      let constData = pub.getConst();
      if (constData) {
        // 匹配状态
        if (constData.matchState) {
          this.matching_options = [{value: -1, label: '匹配状态'}].concat(
            constData.matchState.map(item => ({value: item.value, label: item.name,attr:item.attr}))
          );
        }
        // 审核状态
        if (constData.examineStatus) {
          this.examine_state_options = [{value: -1, label: '审核状态'}].concat(
            constData.examineStatus.map(item => ({value: item.value, label: item.name,attr:item.attr}))
          );
        }
      }
    },
    // 获取匹配状态枚举项
    getMatchStateItem(value) {
      return pub.getConstItem('matchState', value);
    },
    // 获取审核状态枚举项
    getExamineStateItem(value) {
      return pub.getConstItem('examineStatus', value);
    },
    exportClick() {
      let order_start = 0;
      let order_end = 0;
      if (this.order_start) {
        order_start = this.order_start / 1000;
      }
      if (this.order_end) {
        order_end = this.order_end / 1000;
      }

      let params = {
        page: {
          number: 0,
          limit: 1
        },
        keyWord: [],
        parms: {
          // 时间查询改为数组格式：有值才传，否则为空数组
          stTimeFrame: (order_start || order_end)
            ? [
              {
                nStartTime: order_start,
                nEndTime: order_end,
              }
            ]
            : [],
          strProjectName: this.proj_name_search,//发送机构名称
          strCustomerName: this.user_name_search,//姓名
          strCheckupCode: this.exam_code_search,//客户编码
          nExamineStatus: this.examine_state_select,
          nMatchStatus: this.matching_state_select,//是否匹配
        }
      }
      ApiService.ExportHeartOrderData(params).then(res => {
        if (res.code === pub.backCode.SUCCESS) {
          const data = res.data || {};
          const pageList = data.pageList || [];
          const fileUrl = pageList[0].strFileUrl || '';

          if(fileUrl){
            pub.fileLinkToStreamDownload(pub.API_ROOT + '/' + fileUrl, '客户信息列表', 'zip')
          }else{
            pub.tip('导出链接有误,请联系相关人员')
          }
        } else {
          pub.analysisReturnCode(res, this.exportClick);
        }
      }).catch(error => {
        this.loading = false;
        if (error == "Error: Request failed with status code 400") {
          this.$message({
            showClose: true,
            message: error,
            type: 'error',
            duration: 2000
          });
        }
      });
    },
    download(url) {
      if (!url) {
        return
      }
      let link = document.createElement('a');
      link.style.display = 'none'
      link.href = url;
      link.setAttribute('download', '客户信息列表.zip');
      document.body.appendChild(link);
      link.click();
    },
  }
}
</script>

<style scoped lang="scss">
 >>>.form-dialog .mess{
  line-height: 20px;
  text-align: left;
  padding-left: 30px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomerList.vue